import { Component, OnInit, Input } from '@angular/core';
import { Cliente } from '../../cliente/cliente.model';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-usuario-datos-ubicacion-card',
  templateUrl: './usuario-datos-ubicacion-card.component.html',
  styleUrls: ['./usuario-datos-ubicacion-card.component.scss']
})
export class UsuarioDatosUbicacionCardComponent implements OnInit {
  @Input() cliente: Cliente;
  @Input() validacionComponent = false;
  selected = new FormControl(0);

  constructor() { }

  ngOnInit() {

  }

}



// WEBPACK FOOTER //
// ./src/app/shared-components/usuario-datos-ubicacion-card/usuario-datos-ubicacion-card.component.ts